import { render, staticRenderFns } from "./RegraDeAcessos.vue?vue&type=template&id=4587a933&scoped=true"
import script from "./RegraDeAcessos.vue?vue&type=script&lang=js"
export * from "./RegraDeAcessos.vue?vue&type=script&lang=js"
import style0 from "./RegraDeAcessos.vue?vue&type=style&index=0&id=4587a933&prod&lang=scss&scoped=true"
import style1 from "./RegraDeAcessos.vue?vue&type=style&index=1&id=4587a933&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4587a933",
  null
  
)

export default component.exports